<template>
  <div
    class="bg-06-Error-100 rounded-lg p-4"
  >
    <div
      class="flex items-center"
    >
      <IconLoader
        name="ic_circle_error"
        class="w-6 h-6 mr-3 shrink-0"
      />

      <span
        class="font-poppins text-xs font-semibold text-06-Error-700 leading-6.5"
      >
        {{ errors?.message }}
      </span>
    </div>

    <ul
      v-if="hasErrors"
      class="mt-2 ml-9 list-disc space-y-1"
    >
      <li
        v-for="(value, key) in errors?.errors"
        :key="key"
        class="font-poppins text-xs text-06-Error-700 leading-6.5"
      >
        {{ value[0] }}
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { ErrorData } from '~/types/ErrorData'

interface Props {
  errors?: ErrorData
}

const props = defineProps<Props>()

const hasErrors = computed(() => Object.keys(props.errors?.errors ?? {}).length > 0)
</script>
